<div class="course-info" *ngIf="courseTemplate">
  <app-page>
     @if(!isDeployed) {
      <div 
        class="course-unavailable"
        [innerHTML]="'MY-TRAININGS.OVERVIEW.COURSE-NOT-AVAILABLE-DUE-NOT-DEPLOYED' | translate"
      ></div>
    } @else {
      <div class="top-cta">
        <dx-button
          [text]="'COMMON.BACK' | translate"
          icon="back"
          type="default"
          class="integration-btn"
          (click)="navigateBack()"
        >
        </dx-button>
        <div class="right-actions">
          <ng-container *ngIf="isStartRestrictedByLearningPath !== undefined">
            @if(isClosed) {
              @if(isAdmin) {
                <dx-button
                  [text]="'COMMON.ADMIN-VIEW' | translate"
                  type="normal"
                  class="integration-btn"
                  (click)="onAdminViewClick()"
                >
                </dx-button>
              }
            } @else {
              <div
                *ngIf="isStartRestrictedByLearningPath"
                class="course-not-available-text"
              >
                {{ "MY-TRAININGS.OVERVIEW.COURSE-NOT-AVAILABLE-DUE-LEARNING-PATH" | translate }}
              </div>
              <ng-container *ngIf="!isStartRestrictedByLearningPath">
                <div *ngIf="!isTrainingCatalogue && isBookmarked">
                  <div (click)="toggleBookmark()">
                    <i
                      *ngIf="isBookmarked"
                      class="dx-icon dx-svg-icon svg-red"
                      [innerHTML]="getBookmarkIcon()"
                    ></i>
                  </div>
                </div>
                <div *ngIf="isTrainingCatalogue" class="bookmark-extended">
                  <div (click)="toggleBookmark()">
                    <i
                      *ngIf="isBookmarked"
                      class="dx-icon dx-svg-icon svg-red"
                      [innerHTML]="getBookmarkIcon()"
                    ></i>
                    <i
                      *ngIf="!isBookmarked"
                      class="dx-icon dx-svg-icon"
                      [innerHTML]="getBookmarkOutlinedIcon()"
                    ></i>
                  </div>
                  {{
                    !isBookmarked
                      ? ("TRAINING-CATALOGUE.BOOKMARK-EVENT" | translate)
                      : ("TRAINING-CATALOGUE.UNBOOKMARK-EVENT" | translate)
                  }}
                </div>
                @if((!isAdmin && !isManager) || isFromSubscribedSource) {
                  <dx-button
                    [text]="
                      (participationStatus == courseParticipationStatus.Started
                        ? 'MY-TRAININGS.OVERVIEW.CONTINUE-COURSE'
                        : participationStatus == courseParticipationStatus.Completed
                        ? 'MY-TRAININGS.OVERVIEW.REPEAT-COURSE'
                        : 'MY-TRAININGS.OVERVIEW.START-COURSE'
                      ) | translate
                    "
                    type="normal"
                    class="integration-btn"
                    (click)="
                      onStartCourseClick(
                        participationStatus !== courseParticipationStatus.Started && 
                        participationStatus !== courseParticipationStatus.Completed
                      )
                    "
                  >
                  </dx-button>
                } @else if(isAdmin || isManager) {
                  <dx-drop-down-button
                    [splitButton]="true"
                    [text]="
                      (participationStatus == courseParticipationStatus.Started
                        ? 'MY-TRAININGS.OVERVIEW.CONTINUE-COURSE'
                        : participationStatus == courseParticipationStatus.Completed
                        ? 'MY-TRAININGS.OVERVIEW.REPEAT-COURSE'
                        : 'MY-TRAININGS.OVERVIEW.START-COURSE'
                      ) | translate
                    "
                    stylingMode="contained"
                    type="normal"
                    [dropDownOptions]="{ width: 230 }"
                    (onButtonClick)="
                      onStartCourseClick(
                        participationStatus !== courseParticipationStatus.Started && 
                        participationStatus !== courseParticipationStatus.Completed
                      )
                    "
                  >
                    @if(courseTemplateId) {
                      <dxi-item *ngIf="isAdmin" (click)="onAdminViewClick()">
                        {{ "COMMON.ADMIN-VIEW" | translate }}
                      </dxi-item>
                      <dxi-item *ngIf="isManager" (click)="navigateInviteAttendees()">
                        {{ "MANAGE-ELEARNING.DETAIL.ADD-ATTENDEES" | translate }}
                      </dxi-item>
                    }
                  </dx-drop-down-button>
                }
              </ng-container>
            }
          </ng-container>
        </div>
      </div>
      <div *ngIf="isTrainingCatalogue" class="bookmark-extended-mobile">
        <div (click)="toggleBookmark()">
          <i
            *ngIf="isBookmarked"
            class="dx-icon dx-svg-icon svg-red"
            [innerHTML]="getBookmarkIcon()"
          ></i>
          <i
            *ngIf="!isBookmarked"
            class="dx-icon dx-svg-icon"
            [innerHTML]="getBookmarkOutlinedIcon()"
          ></i>
        </div>
        {{
          !isBookmarked
            ? ("TRAINING-CATALOGUE.BOOKMARK-EVENT" | translate)
            : ("TRAINING-CATALOGUE.UNBOOKMARK-EVENT" | translate)
        }}
      </div>
      <div class="course-heading">
        <div class="course-details">
          <div class="course-name">
            {{ courseTemplate.courseTemplate.name }}
          </div>
          <div class="course-stats">
            <div class="course-stats-item">
              {{ "COMMON.FIELDS.TRAINING-TYPE" | translate }}: {{ trainingType }}
            </div>
            <div
              *ngIf="
                courseTemplate.courseTemplate.trainingType == TrainingType.IDD
              "
              class="course-stats-item"
            >
              {{ "COMMON.FIELDS.IDD-TIME-CREDIT" | translate }}:
              {{ durationString }} h
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <app-video-player
          *ngIf="
            courseTemplate.contentFile &&
            courseTemplate.courseTemplate.courseContentType !==
              courseContentTypeModel.AzureScorm
          "
          #videoPlayer
          [videoUrl]="courseTemplate.contentFile.url"
          [hlsUrl]="courseTemplate.contentFile.hlsUrl"
          [allowVideoFastForward]="
            courseTemplate.courseTemplate.allowVideoFastForward
          "
          [videoProgressSeconds]="videoProgressSeconds"
          (progressChanged)="updateVideoProgress($event)"
          (videoEnded)="completeOrRedirectToQuestions().subscribe()"
          (durationChanged)="videoDuration = $event"
        ></app-video-player>
        <div class="col-md-12 col-lg-5 training-image-column">
          <div>
            <div class="course-image-container">
              <img
                class="course-image"
                [src]="
                  (courseTemplate.courseTemplate.customImageFile?.fileUrl ?? courseTemplate.courseTemplate.imageFile?.fileUrl ?? null) 
                  | safe:'url'
                "
                appTrainingImageFallback
              />
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-7">
          <div class="course-widget">
            <div class="course-description">
              {{ courseTemplate.courseTemplate.description! }}
            </div>
            <div class="course-widget-item" *ngIf="courseTemplate.date">
              <div class="course-widget-badge">
                <i
                  class="dx-icon dx-svg-icon"
                  [innerHTML]="getCalendarIcon()"
                ></i>
                {{ "COMMON.FIELDS.PERIOD" | translate }}:
              </div>
              <div class="course-widget-value">
                <div class="course-date">
                  {{ courseTemplate.date.start | date : 'd MMMM yyyy' : '' : translateService.currentLang }}
                  - 
                  {{ courseTemplate.date.end | date : 'd MMMM yyyy' : '' : translateService.currentLang }}
                </div>
              </div>
            </div>
            <div class="course-widget-item" *ngIf="videoDuration">
              <div class="course-widget-badge">
                <i class="dx-icon dx-svg-icon" [innerHTML]="getClockIcon()"></i>
                {{ "COMMON.FIELDS.DURATION" | translate }}:
              </div>
              <div class="course-widget-value">
                <b>{{ videoDuration }} {{ "COMMON.FIELDS.HOURS" | translate }}</b>
              </div>
            </div>
            <div class="course-widget-item" *ngIf="trainingCategories">
              <div class="course-widget-badge category-badge">
                <i
                  class="dx-icon dx-svg-icon"
                  [innerHTML]="getCategoryIcon()"
                ></i>
                {{ trainingCategories }}
              </div>
            </div>
            <div
              class="course-widget-item"
              *ngIf="courseTemplate.courseTemplate.link"
            >
              <div class="course-widget-badge category-badge">
                <i class="dx-icon-link dx-svg-icon-default"></i>
                {{ "MANAGE-ELEARNING.DETAIL.LINK" | translate }}:
              </div>
              <div class="course-widget-value">
                <a [href]="courseTemplate.courseTemplate.link">{{
                  courseTemplate.courseTemplate.link
                }}</a>
              </div>
            </div>
            <div 
              *ngIf="courseTemplate.trainers.length"
              class="trainer"
            >
              <div class="row gy-2">
                @for (trainer of courseTemplate.trainers; track trainer.id) {
                  <div class="col-sm-6 col-md-4 col-lg-3">
                    <app-trainer-card
                      [trainer]="trainer"
                    ></app-trainer-card>
                  </div>
                }
              </div>
            </div>
            <div class="course-widget-item">
              <div class="course-widget-badge">
                <i class="dx-icon-link dx-svg-icon-default"></i>
                {{ "MY-TRAININGS.OVERVIEW.AVAILABLE-FILES" | translate }}:
              </div>
              <div class="course-widget-value">
                <div
                  *ngFor="let file of courseTemplate.files"
                  class="course-item-file"
                >
                  <a [href]="file.fileUrl" target="_blank">
                    {{ file.fileName }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="course-description-widget">
        <div class="course-widget-title">
          {{ "COMMON.FIELDS.DESCRIPTION" | translate }}
        </div>
        <dx-form
          labelLocation="top"
          [showColonAfterLabel]="false"
          [formData]="courseTemplate"
        >
          <dxi-item
            dataField="courseTemplate.descriptionExtended"
            label=""
            editorType="dxHtmlEditor"
            [editorOptions]="{
              label: '',
              height: 'auto',
              readOnly: true
            }"
          >
            <dxo-label text=" "></dxo-label>
          </dxi-item>
        </dx-form>
      </div>
    }
  </app-page>
</div>

<app-course-questions-modal
  [(showModal)]="showModal"
  (submit)="navigateQuestions()"
></app-course-questions-modal>